export const ESCAPE = 27;
export const ENTER = 13;
export const ARROW_RIGHT = 39;
export const ARROW_LEFT = 37;
